module.exports = __webpack_public_path__ + "static/web-hidden-landing-pages-9f1b63fc3cd6742bdd83534fda17be30.gif";